import { useContext } from "react";

import FileContainer from "components/file-container/file-container.component";

import { FolderContext } from "src/contexts/folder.context";

import "./file-selector.style.scss";

const FileSelector = () => {
	const {
		openedFile,
		focusedFiles: { files },
	} = useContext(FolderContext);

	return (
		<div className="file-selector-container">
			<ion-icon id="scroll-button" name="chevron-back-outline" />
			<div className="files-container">
				{files.map(({ file }) => {
					const isSelected = openedFile.file.name === file.name;
					return <FileContainer key={file.name} fileName={file.name} selected={isSelected} />;
				})}
			</div>
			<ion-icon id="scroll-button" name="chevron-forward-outline" />
		</div>
	);
};

export default FileSelector;
